import { SsoCallbackScreen } from "types/Screen";
import { createScreen } from "utils/createScreen";

const SsoCallbackScreenDefinition = createScreen({
  name: SsoCallbackScreen,
  path: "/auth/sso/callback",
  routePath: ["/sso/callback"],
});

export { SsoCallbackScreenDefinition };
